import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import { ROUTER_CONSTANT } from '../../constants/routerConstant';

class IssueCategoryMenu extends Component {
    render() {
        return (
            <div className="menu space-x-7 h-12">
                <NavLink to={ROUTER_CONSTANT.SETTINGS_ISSUE_CATEGORY_PRODUCT}>
                    <span className={
                        window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_ISSUE_CATEGORY_PRODUCT)
                            ? "text-xl text-olddarkblue font-medium border-b-2 border-olddarkblue cursor-pointer px-1 py-2"
                            : "text-xl text-gray-600 font-medium border-b-2 border-transparent cursor-pointer px-1 py-2"
                    }>Produk</span>
                </NavLink>
                <NavLink to={ROUTER_CONSTANT.SETTINGS_ISSUE_CATEGORY_MODULE}>
                    <span className={
                        window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_ISSUE_CATEGORY_MODULE)
                            ? "text-xl text-olddarkblue font-medium border-b-2 border-olddarkblue cursor-pointer px-1 py-2"
                            : "text-xl text-gray-600 font-medium border-b-2 border-transparent cursor-pointer px-1 py-2"
                    }>Modul</span>
                </NavLink>
                <NavLink to={ROUTER_CONSTANT.SETTINGS_ISSUE_CATEGORY_COMPLAINT}>
                    <span className={
                        window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_ISSUE_CATEGORY_COMPLAINT)
                            ? "text-xl text-olddarkblue font-medium border-b-2 border-olddarkblue cursor-pointer px-1 py-2"
                            : "text-xl text-gray-600 font-medium border-b-2 border-transparent cursor-pointer px-1 py-2"
                    }>Kategori Masalah</span>
                </NavLink>
            </div>
        );
    }
}

export default IssueCategoryMenu;